import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import TargetDeliveryTemplateAccessFunctionList from './containers/TargetDeliveryTemplateAccessFunctionList';
import TargetDeliveryTemplateAccessFunctionCreate from './containers/TargetDeliveryTemplateAccessFunctionCreate';
import TargetDeliveryTemplateAccessFunctionEdit from './containers/TargetDeliveryTemplateAccessFunctionEdit';
import TargetDeliveryTemplateAccessFunctionView from './containers/TargetDeliveryTemplateAccessFunctionView';
import { SYSTEM_CONFIGURATION_ROUTE, TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION, TARGET_TEMPLATE } from '../../constants';

interface Props {
}

const TargetDeliveryTemplateAccessFunction: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}`}>
        <TargetDeliveryTemplateAccessFunctionList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}/create`}>
        <TargetDeliveryTemplateAccessFunctionCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}/edit`}>
        <TargetDeliveryTemplateAccessFunctionEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}/view`}>
        <TargetDeliveryTemplateAccessFunctionView />
      </Route>
    </Fragment>
  );
};

export default TargetDeliveryTemplateAccessFunction;
